import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { AccordionContext } from 'react-bootstrap';
import DownChevron from '../../../assets/icons/Down_Chevron_20px_Black.svg';
import RightChevron from '../../../assets/icons/Right_Chevron_20px_Black.svg';

const DormantAccordion = ({ eventKey, callback, projectCount }) => {
    const currentEventKey = useContext(AccordionContext);
    const decoratedOnClick = useAccordionToggle(eventKey, () => callback?.(eventKey));
    const isCurrentEventKey = currentEventKey === eventKey;

    return (
        <button 
            onClick={decoratedOnClick} 
            onKeyDown={(e) => e.key === 'Enter' && decoratedOnClick(e)} 
            className="dormantHeader" 
            aria-label="Toggle Accordion"
        >
            {isCurrentEventKey ? 
                <>
                    <img src={DownChevron} className="dormantChevron" alt="Collapse" />
                    <span>Completed/Archived Projects ({projectCount}) </span>
                </> :
                <>
                    <img src={RightChevron} className="dormantChevron" alt="Expand" />
                    <span>Completed/Archived Projects ({projectCount})</span>
                </>
            }
        </button>
    );
};

DormantAccordion.propTypes = {
    eventKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    callback: PropTypes.func,
    projectCount: PropTypes.number,
};

export default DormantAccordion;